import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  add: '/order/orderReserve/add',
  get: '/order/orderReserve/get',
  listForAppOrPcPage: '/order/orderReserve/listForAppOrPcPage',
  changeOrderStatus: '/order/orderReserve/changeOrderStatus',
};

export const useOrderReserveAdd = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.add,
      method: 'post',
      data: q,
    }, { token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    addHandle: runAsync
  };
};

export const useListForAppOrPcPage = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.listForAppOrPcPage,
      method: 'get',
      data: q || {},
    }, { token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getList: runAsync
  };
};

export const useOrderReserveGet = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.get,
      method: 'get',
      data: q || {},
    }, { token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getDetail: runAsync
  };
};

export const useChangeOrderStatus = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.changeOrderStatus,
      method: 'post',
      data: q || {},
    }, { token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    cencelOrder: runAsync
  };
};
